import { measureLatency } from '../../../gctl-measure';
import { NetworkError, deepCamelCase, searchQueryString } from '../../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetVideoVersionDownloadsFields = readonly string[];

/** Options for GET /videos/{video_id}/versions/{version_id}/downloads */
export type GetVideoVersionDownloadsOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the video.
     */
    videoId: number;
    /**
     * The ID of the video version.
     */
    versionId: number;
  };

  /** Possible query parameters for /videos/{video_id}/versions/{version_id}/downloads */
  query?: {
    /**
     * The ID of the alternate audio track.
     */
    audiotrackId?: string;

    /**
     * The password for the review link.
     */
    password?: string;

    /**
     * The ID of the review link used as context.
     */
    reviewId?: string;
  };
};

/** Result type for GET /videos/{video_id}/versions/{version_id}/downloads */
export type GetVideoVersionDownloadsResult<Paths extends readonly string[]> = unknown;

/**
 * Get a list of downloadable file links for a video with an alternate audio track
 * This method returns a list of downloadable file links for a version of a video that contains the specified alternate audio track.
 */
export async function getVideoVersionDownloads<Paths extends GetVideoVersionDownloadsFields>({
  baseUrl,
  where: { videoId, versionId },
  query,
  ...options
}: GetVideoVersionDownloadsOptions<Paths>): Promise<GetVideoVersionDownloadsResult<Paths>> {
  return measureLatency('getVideoVersionDownloads', 'GET', async () => {
    let res = await fetch(
      `${baseUrl}/videos/${videoId}/versions/${versionId}/downloads?${searchQueryString(query)}`,
      {
        ...options,
        method: 'GET',
      },
    );

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as GetVideoVersionDownloadsResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
